<template lang="pug">
  div
    div.d-flex.justify-start.align-center.mb-1
      v-icon.mr-2(v-if="isArranged" dense color="success500") mdi-check-circle
      v-icon.mr-2(v-if="isFailed" dense color="danger500") mdi-alert-circle
      v-progress-circular.mr-3(v-if="isMatching" :width="3" :size="20" color="info500" indeterminate)
      div.s1.basic700--text {{ name }}
    div.c1.basic600--text.pl-1.mb-4
      template(v-if="isArranged" ) {{ $t('arranged.subtitle') }}
      template(v-if="isFailed" ) {{ $t('failed.subtitle') }}
        slot(name="additionalText")
      template(v-if="isMatching" ) {{ $t('matching.subtitle') }}
</template>

<script>
export default {
  name: 'OngoingHeader',
  props: {
    groupName: {
      type: String,
      required: true
    },
  },
  computed: {
    isArranged() {
      return this.groupName === 'Arranged' 
    },
    isFailed() {
      return this.groupName === 'Failed' 
    },
    isMatching() {
      return this.groupName === 'Matching' 
    },
    name() {
      switch (this.groupName) {
        case 'Arranged':
          return this.$t('arranged.title')

        case 'Failed':
          return this.$t('failed.title')

        case 'Matching':
          return this.$t('matching.title')

        default:
          return ''
      }
    }
  },
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "arranged": {
      "title": "Arranged",
      "subtitle": "We sent your customers their tracking details via SMS"
    },
    "failed": {
      "title": "Failed",
      "subtitle": "Sorry, we could not find riders for these orders. "
    },
    "matching": {
      "title": "Matching",
      "subtitle": "Finding you a rider - this might take a while"
    }
  },
  "id": {
    "arranged": {
      "judul": "Diatur",
      "subtitle": "Kami mengirimkan detail pelacakan pelanggan kamu melalui SMS"
    },
    "faield": {
      "judul": "Gagal",
      "subtitle": "Maaf, kami tidak dapat menemukan rider untuk pesanan ini."
    },
    "matching": {
      "judul": "Mencari rider",
      "subtitle": "Mencarikan kamu rider - ini mungkin memakan waktu cukup lama"
    }
  }
}
</i18n>